import { z } from "zod";

export const manualHoldingSchema = z.object({
  ticker: z
    .string()
    .min(1, "Ticker is required")
    .max(10, "Ticker must be 10 characters or less")
    .regex(/^[A-Z0-9.-]+$/, "Ticker must contain only uppercase letters, numbers, dots, and hyphens")
    .transform((val) => val.toUpperCase()),
  shares: z
    .number({ message: "Shares must be a valid number" })
    .positive("Shares must be greater than 0")
    .finite("Shares must be a finite number"),
  averagePrice: z
    .number({ message: "Average price must be a valid number" })
    .positive("Average price must be greater than 0")
    .finite("Average price must be a finite number"),
});

export const manualHoldingsFormSchema = z
  .object({
    holdings: z
      .array(manualHoldingSchema)
      .max(50, "Maximum 50 holdings can be added at once"),
  })
  .refine(
    (data) => {
      // Check for duplicate tickers (only if there are holdings)
      if (data.holdings.length === 0) return true;
      const tickers = data.holdings.map((h) => h.ticker.toUpperCase());
      const uniqueTickers = new Set(tickers);
      return tickers.length === uniqueTickers.size;
    },
    {
      message: "Duplicate tickers are not allowed",
      path: ["holdings"],
    }
  );

export type ManualHoldingFormData = z.infer<typeof manualHoldingSchema>;
export type ManualHoldingsFormData = z.infer<typeof manualHoldingsFormSchema>;